<div class="dialog-title fs-24 fw-700">{{'SIZING.SIZING_DOCUMENT' | transloco}}</div>
<div class="close-icon">
	<mat-icon svgIcon="close" class="cursor-pointer" (click)="dialogRef.close()"></mat-icon>
</div>

<div class="body flex flex-col mb-24">
  <div class="flex flex-col">
		<div class="dialog-message fs-16 fw-500">{{mode === SizingDialogMode.CREATE_WITH_EXISTING ? ('SIZING.CONFIRMATION_EXISTING' | transloco) : ('SIZING.CONFIRMATION' | transloco)}}</div>
		  <label class="label fs-12 fw-700">
			{{mode === SizingDialogMode.CREATE_WITH_EXISTING ? ('SIZING.SELECTED_DOCUMENT_NAME' | transloco | uppercase) : ('SIZING.DOCUMENT_NAME' | transloco | uppercase)}}
		  </label>
		  <span *ngIf="nameSuffix" class="name-preview fs-12">Sizing_{{documentNameControl.value || 'Default'}}{{nameSuffix}}</span>
		  <input type="text" class="input-field" [formControl]="documentNameControl" [ngClass]="{ 'input-size': isReadOnlyMode }" placeholder="{{'SIZING.INPUT_DOCUMENT' | transloco}}"/>
    	  <app-error [control]="documentNameControl"></app-error>
  	</div>
	<div *ngIf="mode !== 'SUBMIT'" class="flex flex-col mb-12">
  		<label class="choose-label fs-12 fw-700">
    		{{'INFRA.CHOOSE_SIZE' | transloco | uppercase}}
  		</label>
		<select class="select-size" [(ngModel)]="selectedSize" (change)="onSizeChange($event)">
			<option value="XXS-Small">XXS-Small</option>
			<option value="Large">Large</option>
			<option value="Medium">Medium</option>
			<option value="X-Small">X-Small</option>
		</select>
		<div class="error-text" *ngIf="sizeError">{{ sizeError }}</div>
	</div>
</div>
<mat-divider class="divider"></mat-divider>
<div class="dialog-actions">
	<button class="cancel-btn" (click)="cancel()">{{'BUTTONS.CANCEL' | transloco}}</button>
	<button class="confirm-btn" [disabled]="sizeError || (!isReadOnlyMode && documentNameControl.invalid)" (click)="confirm()">{{'BUTTONS.CONFIRM' | transloco}}</button>
</div>